import { render } from "./EditCalendarExercise.vue?vue&type=template&id=0cd01567"
import script from "./EditCalendarExercise.vue?vue&type=script&lang=js"
export * from "./EditCalendarExercise.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__